<template>
    <div :class="{ 'invalid-feedback': error }" v-show="error" style="display: block">
        <span>{{ error }}</span>
    </div>
</template>
<script>
    export default {

        props: {
            classes: {
                type: String,
                default: ""
            },
            errors: {},
        },

        computed: {

            error() {
                return this.errors && this.errors.length ? this.errors[0] : null;
            }
        }

    }
</script>


// WEBPACK FOOTER //
// resources/js/components/common/Error.vue